export default [
  {
    path: "/alllocations",
    name: "alllocations",
    component: () => import("@/views/locations.vue"),
    meta: {
      pageTitle: "Locations",
      requiresAuth: true,
      breadcrumb: [
        {
          text: "Manage Locations",
          active: true,
        },
      ],
    },
  },
];
